import { FC } from "react";
import PageContainer from "src/pages/components/PageContainer";
import CompanyDashboard from "src/pages/Company/Dashboard/CompanyDashboard";
import { isUserAdministrator, isUserCompany } from "src/utils/auth";

const SuaEmpresa: FC = (): JSX.Element => {
  const isCompanyUser = isUserCompany() && !isUserAdministrator();

  return (
    <PageContainer title="Métricas de engajamento" guard={() => isCompanyUser}>
      <CompanyDashboard />
    </PageContainer>
  );
};

export default SuaEmpresa;
